import { ExamFormValues, normalizeRequestWithDate } from '@shared';
import { API_ROUTES, request, requestWithPaginationHeader } from '../instance';

export type ExamData = {
  id: number;
  label: string;
  uuid: string;
  proctoringType?: string;
  password: string;
  recordOnly: boolean;
  practice: boolean;
  startTime: number[] | null;
  endTime: number[];
  url: string;
  enableSecureBrowser: boolean;
  disableNavigation: boolean;
  disablePrintScreen: boolean;
  disableCopyPaste: boolean;
  forceFullScreen: boolean;
  enableWhitelistedUrls: boolean;
};
export type ExamAPI = {
  exam: ExamData;
  proctoringType?: string;
  studentCount: number;
  completedExamCount: number;
  whitelistedUrls: string;
};

export const getPack = (partner: string, course: string, offset = 0) => {
  return requestWithPaginationHeader<ExamAPI[]>({
    url: `${API_ROUTES.exams(partner, course, offset)}`,
    method: 'GET',
  });
};

export const get = (exam: string) => {
  return request<ExamAPI>({
    url: `${API_ROUTES.exam(exam)}`,
    method: 'GET',
  });
};

export const addExam = (partner: string, course: string, data: ExamFormValues) => {
  return request({
    url: API_ROUTES.addExam(partner, course),
    method: 'POST',
    data: normalizeRequestWithDate(data),
  });
};

export const updateExam = (partner: string, course: string, exam: string, data: ExamFormValues) => {
  return request({
    url: API_ROUTES.updateExam(partner, course, exam),
    method: 'PUT',
    data: normalizeRequestWithDate(data),
  });
};
